export default defineNuxtRouteMiddleware((to) => {
  const { data, status } = useAuth()
  const { rawToken } = useAuthState()

  if (
    to.meta.layout !== 'account'
    || status.value !== 'authenticated'
    || !data.value?.agencyId
  ) {
    return
  }

  return navigateTo(
    {
      path: externalUrl('agency', { name: '/' }),
      query: {
        accessToken: rawToken.value,
      },
    },
    { external: true },
  )
})
